import hyperdom from 'hyperdom'
import hobostyle from 'hobostyle'
import * as gtmDataLayer from './analytics/gtm/dataLayer.js'

class Modals {
  constructor () {
    this.style = hobostyle.style('')
    this.modals = []
    this.body = document.querySelector('body')
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  stopBodyScroll (modal) {
    (!modal || !modal.allowBodyScroll) && this.style.set('body { overflow: hidden }')
  }

  startBodyScroll () {
    this.style.set('')
  }

  async show (modal) {
    this.body.style.overflow = 'hidden'
    this.modals.push(modal)
    this.stopBodyScroll(modal)
  }

  async close () {
    if (this.modals.length === 0) return
    const actualModal = this.modals[this.modals.length - 1]
    actualModal && actualModal.close && actualModal.close()
    this.modals.pop()
    this.body.style.overflowY = 'scroll'

    if (this.modals.length === 0) {
      this.startBodyScroll()
    }
  }

  render () {
    const modal = this.modals[this.modals.length - 1]
    if (modal && modal.render) {
      return modal.fullscreen ? this.renderFullscreen(modal) : this.renderCentered(modal)
    }
  }

  renderFullscreen (modal) {
    return <div data-test={modal.dataTest} className={['o-fullscreen-modal', modal.classNames || '', modal.isClosing ? modal.closingAnimation : '' ]}>
      {modal.render()}
    </div>
  }

  renderCentered (modal) {
    return <div className={'o-centered-modal-wrapper'} onclick={() => { !modal.backdropCloseDisabled && this.close() }}>
      <div data-test={modal.dataTest} className={['o-centered-modal', modal.classNames || '', modal.isClosing ? modal.closingAnimation : '' ]}
        onclick={(ev) => ev.stopPropagation()}>
        {modal.render()}
      </div>
    </div>
  }
}

export default Modals
